import { render } from "./Gradient.vue?vue&type=template&id=28c862cc"
import script from "./Gradient.vue?vue&type=script&lang=js"
export * from "./Gradient.vue?vue&type=script&lang=js"
script.render = render

export default script